export default "__VITE_ASSET__BSKCkfZH__"